<template>
  <div class="bg-muted rounded-sm my-0.5">
    <h4 class="uppercase rounded-sm px-6 flex justify-between">
      <p>
        {{ job.filename }} - material: {{ materialName }} - units:
        {{ unitName }} - Count: {{ job.params.times_cut }}

        <i
          :class="`fas fa-chevron-${expandForm ? 'up' : 'down'} cursor-pointer`"
          @click="toggleExpandForm"
        />
      </p>
      <i
        class="far fa-window-close cursor-pointer"
        @click="emitRemoveJob"
      />
    </h4>
    <div
      v-show="expandForm"
      class="bg-white w-full p-0.5"
    >
      <slot />
    </div>
  </div>
</template>
<script>
export default {
  name: 'JobContainer',
  props: {
    job: {
      type: Object,
      required: true,
    },
    materialOptions: {
      type: Array,
      required: true,
      default: () => [],
    },
    unitOptions: {
      type: Array,
      required: true,
      default: () => [],
    },
  },
  data () {
    return {
      expandForm: true,
    }
  },
  computed: {
    materialName () {
      const material = this.materialOptions.find(
        option => option.id === +this.job.material
      )
      return material ? material.name : ''
    },
    unitName () {
      const unit = this.unitOptions.find(
        option => option.id === +this.job.params.scale
      )
      return unit ? unit.short : ''
    },
  },
  methods: {
    toggleExpandForm () {
      this.expandForm = !this.expandForm
    },
    emitRemoveJob () {
      this.$emit('remove-job')
    },
  },
}
</script>
